import $ from 'jquery';

$(function(){

/* toggler submenu */
function toggle_submenu(elem) {
    var subMenu = $(elem).children('.dropdown-menu');
    var delay = 0;
    var isActive = $(elem).children('.dropdown-menu').hasClass('show');
    if(isActive){
      subMenu.removeClass("show");
      $(elem).children('a.nav-link').attr("aria-expanded","false");
    } else {
      subMenu.addClass("show");
      $(elem).children('a.nav-link').attr("aria-expanded","true");
    }
    subMenu.children().each(function (){
      if(!isActive)
      delay += 50;
      $(this).delay(delay).queue(function(){
        $(this).toggleClass("toggle")
        $(this).dequeue();
      });
    });
  }

  /**$('body').on('click', '#mobile-menu li.menu-item-has-children > a',function (e) {
    e.preventDefault();
    var $this = $(this);
    var parent = $this.parent('li.menu-item-has-children');
    toggle_submenu(parent);
  });*/
  $('body').on('mouseenter mouseleave','#main-menu li.menu-item-has-children',function () {
    toggle_submenu($(this));
  });
});